<script>
  import { onMount } from 'svelte';
  import * as XLSX from 'xlsx';

  let fileInput;
  let uploadResult = '';

  let manualOrder = {
    order_date: '',
    client_name: '',
    project_name: '',
    part_no: '',
    order_no: '',
    quantity: '',
    due_date: '',
    remarks: ''
  };

  let insertResult = '';

  onMount(() => {
    const today = new Date().toISOString().slice(0, 10);
    manualOrder.order_date = today;
    manualOrder.due_date = today; // ✅ 납기일도 기본값 설정
  });



  function openFileDialog() {
    fileInput.click();
  }

  // async function handleExcelUpload(event) {
  //   const file = event.target.files[0];
  //   if (!file) return;

  //   const reader = new FileReader();
  //   reader.onload = async (e) => {
  //     const data = new Uint8Array(e.target.result);
  //     const workbook = XLSX.read(data, { type: 'array' });

  //     const sheet = workbook.Sheets[workbook.SheetNames[0]];
  //     const json = XLSX.utils.sheet_to_json(sheet, { defval: '', raw: false });

  //     if (!json.length) {
  //       uploadResult = '❌ 데이터가 비어있습니다.';
  //       return;
  //     }

  //     const headers = Object.keys(json[0]);
  //     let type = '';

  //     if (headers.includes('업체') && headers.includes('불출일')) {
  //       type = 'type1';
  //     } else if (headers.includes('작지상태') && headers.includes('품목코드')) {
  //       type = 'type2';
  //     } else {
  //       uploadResult = '❌ 인식할 수 없는 엑셀 양식입니다.';
  //       return;
  //     }

  //     const expandedRows = [];

  //     for (const row of json) {
  //       const quantity = parseInt(type === 'type1' ? row['Qty'] : row['수량']) || 0;

  //       expandedRows.push({
  //         order_date: new Date().toISOString().slice(0, 10),
  //         client_name: type === 'type1' ? '현항공' : 'ATS',
  //         project_name: type === 'type1' ? row['Project'] : row['사업'],
  //         part_no: type === 'type1' ? row['Part No.'] : row['품목코드'],
  //         order_no: type === 'type1' ? row['Order No.'] : row['작지번호'],
  //         quantity,
  //         due_date: parseDate(type === 'type1' ? row['입고요구일'] : row['ERP 공정목표일']),
  //         remarks: type === 'type1' ? row['비고(현항공)'] : row['현공정 REMARK'],
  //         material_ready: null,
  //         process_start: null,
  //         process_end: null,
  //         process_id: null,
  //         add_process_start: null,
  //         add_process_end: null,
  //         add_process_id: null,
  //         post_process_start: null,
  //         post_process_end: null,
  //         post_process_id: null,
  //         inspection_end: null,
  //         other_process: null,
  //         shipment: null
  //       });
  //     }

  //     const response = await fetch('/api/upload-orders', {
  //       method: 'POST',
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify({ type, rows: expandedRows })
  //     });

  //     const result = await response.text();
  //     uploadResult = result;
  //   };

  //   reader.readAsArrayBuffer(file);
  // }

  async function handleExcelUpload(event) {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = async (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });

      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const json = XLSX.utils.sheet_to_json(sheet, { defval: '', raw: false });

      if (!json.length) {
        uploadResult = '❌ 데이터가 비어있습니다.';
        return;
      }

      const headers = Object.keys(json[0]);
      let type = '';

      if (headers.includes('업체') && headers.includes('불출일')) {
        type = 'type1';
      } else if (headers.includes('작지상태') && headers.includes('품목코드')) {
        type = 'type2';
      } else if (
        headers.includes('client_name') &&
        headers.includes('project_name') &&
        headers.includes('part_no') &&
        headers.includes('order_no') &&
        headers.includes('quantity') &&
        headers.includes('due_date') &&
        headers.includes('remarks')
      ) {
        type = 'type3';
      } else {
        uploadResult = '❌ 인식할 수 없는 엑셀 양식입니다.';
        return;
      }

      const expandedRows = [];

      for (const row of json) {
        let quantity = 0;
        let dueDate = '';
        let orderRow = {};

        if (type === 'type1') {
          quantity = parseInt(row['Qty']) || 0;
          dueDate = parseDate(row['입고요구일']);
          orderRow = {
            order_date: new Date().toISOString().slice(0, 10),
            client_name: '현항공',
            project_name: row['Project'],
            part_no: row['Part No.'],
            order_no: row['Order No.'],
            quantity,
            due_date: dueDate,
            remarks: row['비고(현항공)']
          };
        } else if (type === 'type2') {
          quantity = parseInt(row['수량']) || 0;
          dueDate = parseDate(row['ERP 공정목표일']);
          orderRow = {
            order_date: new Date().toISOString().slice(0, 10),
            client_name: 'ATS',
            project_name: row['사업'],
            part_no: row['품목코드'],
            order_no: row['작지번호'],
            quantity,
            due_date: dueDate,
            remarks: row['현공정 REMARK']
          };
        } else if (type === 'type3') {
          quantity = parseInt(row['quantity']) || 0;
          dueDate = parseDate(row['due_date']);
          orderRow = {
            order_date: new Date().toISOString().slice(0, 10),
            client_name: row['client_name'],
            project_name: row['project_name'],
            part_no: row['part_no'],
            order_no: row['order_no'],
            quantity,
            due_date: dueDate,
            remarks: row['remarks']
          };
        }

        // 공통 필드 초기화
        expandedRows.push({
          ...orderRow,
          material_ready: null,
          process_start: null,
          process_end: null,
          process_id: null,
          add_process_start: null,
          add_process_end: null,
          add_process_id: null,
          post_process_start: null,
          post_process_end: null,
          post_process_id: null,
          inspection_end: null,
          other_process: null,
          shipment: null
        });
      }

      const response = await fetch('/api/upload-orders', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ type, rows: expandedRows })
      });

      const result = await response.text();
      uploadResult = result;
    };

    reader.readAsArrayBuffer(file);
  }

  function parseDate(value) {
    if (!value) return null;
    if (typeof value === 'string') {
      const d = new Date(value);
      if (isNaN(d.getTime())) return null;
      d.setHours(d.getHours() + 9);
      return d.toISOString().slice(0, 10);
    }
    if (typeof value === 'number') {
      const offset = value >= 60 ? 1 : 0;
      const date = new Date(Date.UTC(1899, 11, 30 + value + offset));
      date.setHours(date.getHours() + 9);
      return date.toISOString().slice(0, 10);
    }
    return null;
  }

  function validateManualOrder(order) {
    const requiredFields = [
      'order_date',
      'client_name',
      'project_name',
      'part_no',
      'order_no',
      'quantity',
      'due_date',
      'remarks'
    ];

    for (const field of requiredFields) {
      if (!order[field] || String(order[field]).trim() === '') {
        return `❌ '${field}' 항목이 비어 있습니다.`;
      }
    }

    if (isNaN(parseInt(order.quantity)) || parseInt(order.quantity) <= 0) {
      return '❌ 수량은 1 이상의 숫자여야 합니다.';
    }

    return null; // 모든 항목이 유효함
  }

  async function submitManualOrder() {
    const error = validateManualOrder(manualOrder);
    if (error) {
      insertResult = error;
      return;
    }

    const payload = {
      type: 'manual',
      rows: [manualOrder]
    };

    try {
      const response = await fetch('/api/upload-orders', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        insertResult = '❌ 서버 에러가 발생했습니다.';
        return;
      }

      const result = await response.text();
      insertResult = result;

      // 입력값 초기화
      const today = new Date().toISOString().slice(0, 10);
      manualOrder = {
        order_date: today,
        client_name: '',
        project_name: '',
        part_no: '',
        order_no: '',
        quantity: '',
        due_date: today,
        remarks: ''
      };
    } catch (err) {
      insertResult = '❌ 서버 통신 오류';
    }
  }
</script>

<main>
  <!-- <h3>Order</h3> -->

  <div class="upload-container">
    <div class="upload-header">
      <h4>엑셀데이터 업로드(xlsx)</h4>
      <button on:click={openFileDialog}>엑셀 파일 선택</button>
    </div>
    <input type="file" bind:this={fileInput} accept=".xlsx,.xls" on:change={handleExcelUpload} style="display: none;" />
    <p>{uploadResult}</p>
  </div>

  <!-- 수작업 입력 폼 -->
  <div class="manual-container">
    <h4>오더 입력</h4>

    <div class="form-grid">
      <div class="form-item">
        <!-- svelte-ignore a11y-label-has-associated-control -->
        <label>오더날짜</label>
        <input type="date" bind:value={manualOrder.order_date} />
      </div>

      <div class="form-item">
        <!-- svelte-ignore a11y-label-has-associated-control -->
        <label>납기일</label>
        <input type="date" bind:value={manualOrder.due_date} />
      </div>

      <div class="form-item">
        <!-- svelte-ignore a11y-label-has-associated-control -->
        <label>발주처</label>
        <input type="text" placeholder="발주처를 입력하세요" bind:value={manualOrder.client_name} />
      </div>

      <div class="form-item">
        <!-- svelte-ignore a11y-label-has-associated-control -->
        <label>사업명</label>
        <input type="text" placeholder="프로젝트명을 입력하세요" bind:value={manualOrder.project_name} />
      </div>

      <div class="form-item">
        <!-- svelte-ignore a11y-label-has-associated-control -->
        <label>품목</label>
        <input type="text" placeholder="품목을 입력하세요" bind:value={manualOrder.part_no} />
      </div>

      <div class="form-item">
        <!-- svelte-ignore a11y-label-has-associated-control -->
        <label>오더넘버</label>
        <input type="text" placeholder="오더넘버를 입력하세요(중복된 오더넘버는 입력되지않습니다.)"bind:value={manualOrder.order_no} />
      </div>

      <div class="form-item">
        <!-- svelte-ignore a11y-label-has-associated-control -->
        <label>수량</label>
        <input type="number" placeholder="1개이상의 수량을 입력하세요" bind:value={manualOrder.quantity} min="1" />
      </div>

      <div class="form-item">
        <!-- svelte-ignore a11y-label-has-associated-control -->
        <label>비고</label>
        <textarea placeholder="메모를 입력해주세요" bind:value={manualOrder.remarks} rows="2" />
      </div>
    </div>

    <div class="submit-row">
      <button on:click={submitManualOrder}>등록</button>
    </div>

    <p>{insertResult}</p>
  </div>

</main>


<style>
  main {
    margin-top: 20px;
    padding: 1rem;
    max-width: 100%;
    box-sizing: border-box;
  }
  h4{
    color:#ffc400
  }

  .upload-container {
    border: 1px solid #cfcfca; /* Light border for tables */
    background-color: #fcfcf8;
    padding: 1rem;
    border-radius: 0px;
    margin-bottom: 30px;
    width: 100%;
  }
  /* .upload-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  } */
  .upload-header {
  display: flex;
  align-items: center; /* ✅ 세로 중앙 정렬 */
  justify-content: space-between;
  
}
.upload-header button {
  /* padding: 8px 16px; */
  font-size: 0.8rem;
  height: 40px; /* ✅ h4와 시각적으로 맞춤 */
  cursor: pointer;
}


  button {
    width: 50%;
    padding: 10px;
    margin-top: 12px;
    border: none;
    border-radius: 6px;
    background-color: #b6b69e;
    color: #fff;
    font-size: 1rem;
    cursor: pointer;
  }
  button:hover {
    background-color: #92927b;
  }

  .manual-container {
    border: 1px solid #cfcfca; /* Light border for tables */
    background-color: #fcfcf8;
    padding: 1rem;
    border-radius: 6px;
    margin-top: 40px;
  }

  .form-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }
  .form-item {
    display: flex;
    flex-direction: column;
  }
  .form-item label {
    font-weight: bold;
    margin-bottom: 4px;
  }
  .form-item input:not([type="date"]),
  .form-item textarea {
    padding: 8px;
    font-size: 1rem;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
  .form-item input::placeholder,
  .form-item textarea::placeholder {
    color: #bbbbbb; /* 연한 회색 */
  }


  .form-item input,
  .form-item textarea {
    /* padding: 8px; */
    font-size: 1rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    height: 60px;
    box-sizing: border-box;
  }

  .submit-row {
    display: flex;
    justify-content: center;
    margin-top: 24px;
  }
  .submit-row button {
    width: 200px;
    padding: 12px;
    background-color: #b6b69e;
    color: white;
    font-size: 1rem;
    border: none;
    border-radius: 6px;
    cursor: pointer;
  }
  .submit-row button:hover {
    background-color: #92927b;
  }


  @media (max-width: 768px) {
  .form-grid {
    grid-template-columns: 1fr;
  }

  .submit-row button,
  button {
    width: 100%;
  }

  .form-item input,
  .form-item textarea {
    height: auto;
    min-height: 48px;
  }

  .upload-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}

</style>
